export const FETCH_COMBINED_PRACTITIONER_REQUEST = "FETCH_COMBINED_PRACTITIONER_REQUEST";
export const FETCH_COMBINED_PRACTITIONER_SUCCESS = "FETCH_COMBINED_PRACTITIONER_SUCCESS";
export const FETCH_COMBINED_PRACTITIONER_FAILURE = "FETCH_COMBINED_PRACTITIONER_FAILURE";
